import { Catalogs, I18n, setupI18n as linguiSetupI18n } from '@lingui/core';
import * as Cookies from 'es-cookie';

export const getCurrentLanguage = (): string => {
    try {
        return document?.documentElement?.getAttribute('lang') || Cookies.get('django_language') || 'en';
    } catch (e) {
        return 'en';
    }
};

export let i18n: I18n;

export function setupI18n(language: string, catalogs: Catalogs) {
    i18n = linguiSetupI18n({
        language,
        catalogs,
    });
}
